import { Card, Row } from 'antd'
import React from 'react'
import Heading from '../../../component/common/Heading'
import CRUDComponent from '../../../component/common/CRUD-Component'
import CONSTANTS from '../../../util/constant/CONSTANTS'
import { convertUTCToLocal } from '../../../util/functions'

const LocationHistory = ({ devic }) => {
    return (
        <>
            <Card className="mt-5">
                <Heading>Location History</Heading>

                <Row>
                    <CRUDComponent
                        GET={{
                            API: CONSTANTS.API.Location_history.getAll,

                            DataModifier: (res, API, Setrefresh) => {
                                // console.log(res, "GET ALL ABCD");
                                return res?.map(data => {
                                    return {
                                        ...data,
                                        no: `LH${data?.id.toString().padStart(7, "0")}`,
                                        admin: data?.Admin?.name,
                                        pet: data?.pet?.name,
                                        userName: data?.pet?.user?.name,
                                        date: convertUTCToLocal(data?.createdAt, 'DD MMM YYYY hh:mm A'),

                                    }
                                })
                            },
                            column: CONSTANTS.TABLE.LOCATION_HISTORY_LIST,
                        }}
                        isSearch={true}

                    />
                </Row>

            </Card>
        </>
    )
}

export default LocationHistory